export default "__VITE_ASSET__BjrcDINf__"